export const mealAmountValueTypeConstants = [
    { name: "Flat Amount", value: "flat" },
    { name: "Per head meal percentage", value: "percentage" },
];
